import { Service, signal } from '@angular/core';
import { Subject } from 'rxjs';

/** Diffuse les enregistrements et suppressions confirmés aux vues affichant des interventions. */
@Service()
export class InterventionActualisation {
  /** Compteur pour les consommateurs réactifs qui relisent l’ensemble de leur liste. */
  readonly revision = signal(0);
  private readonly modifications = new Subject<{
    installationId: number;
    ticketId: number | null;
  }>();
  /** Contexte pour les consommateurs qui ne rechargent que le ticket ou la centrale concernés. */
  readonly changements = this.modifications.asObservable();

  /** À appeler après succès serveur, jamais lors d’une simple tentative d’enregistrement. */
  notifier(installationId: number, ticketId: number | null): void {
    this.revision.update((v) => v + 1);
    this.modifications.next({ installationId, ticketId });
  }
}
